import { useAppSelector } from './index';
import { DEFAULT_GOAL_CATEGORY, EWS_DURATION_MAP, EWS_TERM_TAB_KEY_MAP, EwsDuration, EwsDurationKey, TermTabType } from '../constants';

/**
 * Resolves which EWS term the Funding Navigator is scoped to. Multiportfolio tenants (Banorte) follow the
 * selected Short/Medium/Long tab; single-portfolio tenants have one `default` term and no tabs.
 */
export const useFundingTermScope = (
    selectedTermIndex: TermTabType
): { isMultiPortfolioTenant: boolean; durationKey: EwsDurationKey; duration: EwsDuration } => {
    const isMultiPortfolioTenant = useAppSelector((state) => Boolean(state?.global?.globalConfig?.isMultiPortfolioTenant));
    const durationKey = isMultiPortfolioTenant ? EWS_TERM_TAB_KEY_MAP[selectedTermIndex] : DEFAULT_GOAL_CATEGORY;
    return { isMultiPortfolioTenant, durationKey, duration: EWS_DURATION_MAP[durationKey] };
};
